import { useEffect, useState } from "react";
import Apiservice from "../Apiservice";

const FloaterPage = () => {
    const [floaterCredits, setFloaterCredits] = useState([]);
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            let result = await Apiservice.FloaterCreditGet({ status: 0 });
            if (result.success === true) {
                setFloaterCredits(result.data);
            }
        };
        fetchData();
    }, []);

    const handleEdit = (id) => {
        setEditId(id);
    };

    const handleCancel = () => {
        setEditId(null);
    };

    const handleChange = (id, field, value) => {
        setFloaterCredits(prev =>
            prev.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

    const handleDelete = (id) => {
        alert(`Delete ID: ${id}`);
        // call delete API here
    };

    return (
        <div className="container mt-4">
            <div className="card shadow p-4 rounded-4">
                <h5 className="text-center text-primary mb-4">
                    Floater Credentials
                </h5>

                {floaterCredits.length > 0 ? (
                    floaterCredits.map((credits) => {
                        const isEdit = editId === credits.id;

                        return (
                            <div
                                className="border rounded p-3 mb-3"
                                key={credits.id}
                            >
                                {/* Username */}
                                <div className="row align-items-center mb-2">
                                    <div className="col-3 fw-semibold">
                                        Username
                                    </div>
                                    <div className="col-1">:</div>
                                    <div className="col">
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={credits.username}
                                            disabled={!isEdit}
                                            onChange={(e) =>
                                                handleChange(
                                                    credits.id,
                                                    "username",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>
                                </div>

                                {/* Password */}
                                <div className="row align-items-center mb-3">
                                    <div className="col-3 fw-semibold">
                                        Password
                                    </div>
                                    <div className="col-1">:</div>
                                    <div className="col">
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={credits.password}
                                            disabled={!isEdit}
                                            onChange={(e) =>
                                                handleChange(
                                                    credits.id,
                                                    "password",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="text-end">
                                    {isEdit ? (
                                        <>
                                            <button
                                                className="btn btn-success btn-sm me-2"
                                                onClick={() => setEditId(null)}
                                            >
                                                Save
                                            </button>
                                            <button
                                                className="btn btn-secondary btn-sm"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                className="btn btn-primary btn-sm me-2"
                                                onClick={() =>
                                                    handleEdit(credits.id)
                                                }
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() =>
                                                    handleDelete(credits.id)
                                                }
                                            >
                                                Delete
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p className="text-center text-muted">
                        No records found
                    </p>
                )}
            </div>
        </div>
    );
};

export default FloaterPage;
